module.exports = __webpack_public_path__ + "img/workout_no_image.c9673446.png";